import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CarritoService } from '../../services/carrito.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-failure',
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './failure.component.html',
  styleUrl: './failure.component.scss'
})
export class FailureComponent {

  public showSpinner: boolean = true;
  public showError: boolean = false;
  public detalleComra: any = {};

  constructor(private carritoService: CarritoService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    const guid = this.route.snapshot.queryParams['preference_id'];
    this.carritoService.cancelarCompra({
      guid: guid
    }).subscribe({
      next: () => {
        this.showSpinner = false;
      }, error: () => {
        this.showSpinner = false;
      }
    });

  }

}
